var _templateObject, _templateObject2, _templateObject3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import styled from 'styled-components';
import shallow from 'zustand/shallow';
import useStore from './../store';
import { Header, Logo, Canvas, CoreButton, MenuIcon } from './../../../core';
import { GeocodeSearch } from './../GeocodeSearch';
import ControlPanel from './../ControlPanel/ControlPanel';
import MapView from './../MapView/MapView';
import SlideoutPanel from './../SlideoutPanel/SlideoutPanel';
import IntroModal from './../IntroModal/IntroModal';
import { FeedbackModal } from './../Feedback';
import { ShareLinkModal, UnifiedShareModal } from './../Share';
import Tour from './../Tour/Tour';
import { Tracking } from './../Tracking';
import { variables } from './../theme';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var Layout = function Layout(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic state updates for store.
  // Accepts an object of values to update.


  var _useStore = useStore(function (state) {
    return {
      activeView: state.activeView,
      handleToggleMenu: state.handleToggleMenu,
      breakpoint: state.breakpoint,
      logoSrc: state.logoSrc
    };
  }, shallow),
      activeView = _useStore.activeView,
      handleToggleMenu = _useStore.handleToggleMenu,
      breakpoint = _useStore.breakpoint,
      logoSrc = _useStore.logoSrc;

  var MapViewContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    padding-left: ", ";\n  "])), (breakpoint === 'lg' || breakpoint === 'xl') && activeView === 'explorer' ? variables.dimensions.controlPanelWidth : 0);
  var AppCanvas = styled(Canvas)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 100%;\n  "])));
  var Main = styled.main(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    height: ", ";\n  "])), activeView === 'explorer' ? "calc(100vh - " + variables.dimensions.navbarHeight + ")" : "100vh"); // Basic props for logo component.

  var logoProps = {
    siteName: i18n.translate("SITE_TITLE"),
    siteHref: useStore(function (state) {
      return state.siteHref;
    })
  }; // Handle clicks to any control panel button.

  var handleClick = function handleClick(e) {
    e.preventDefault(); // console.log('Button clicked, ', e.currentTarget.id)

    if (e.currentTarget.id === 'button_toggle_menu') {
      // console.log('toggle menu clicked')
      if (!!handleToggleMenu) {
        handleToggleMenu();
      }
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('bs-expl', // explorer bootstrap override class
    'layout', 'breakpoint-' + breakpoint, 'view-' + activeView)
  }, props), /*#__PURE__*/React.createElement(Tracking, null), activeView === 'explorer' && /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Logo, logoProps, /*#__PURE__*/React.createElement("div", {
    className: "cpal-logo",
    role: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "logo",
    dangerouslySetInnerHTML: {
      __html: logoSrc
    },
    role: "img",
    "aria-label": i18n.translate("SITE_TITLE") + " logo"
  })), /*#__PURE__*/React.createElement(GeocodeSearch, null), /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_toggle_menu",
    "aria-label": i18n.translate("BUTTON_MENU"),
    onClick: handleClick,
    color: "none",
    className: "button-toggle-menu"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-icon-group"
  }, /*#__PURE__*/React.createElement(MenuIcon, null), i18n.translate("BUTTON_MENU")))), /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(AppCanvas, null, activeView === 'explorer' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideoutPanel, null), /*#__PURE__*/React.createElement(ControlPanel, null)), /*#__PURE__*/React.createElement(MapViewContainer, {
    className: clsx('view-parent', activeView ? 'display-' + activeView : 'display-map')
  }, /*#__PURE__*/React.createElement(MapView, null)), activeView === 'explorer' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ShareLinkModal, {
    className: "modal-share-link"
  }), /*#__PURE__*/React.createElement(UnifiedShareModal, {
    className: "modal-u-share"
  }), /*#__PURE__*/React.createElement(IntroModal, null), /*#__PURE__*/React.createElement(Tour, null), /*#__PURE__*/React.createElement(FeedbackModal, null)))));
};

export default Layout;